<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop" style="text-align: center;">The night comes on;</p>
<p class="first" style="text-align: center;">You wait and listen…</p>
<p class="first" style="text-align: center;">To all these ghosts of change.</p>
<p class="first" style="text-align: center;">They are you.</p>
<p class="first" style="text-align: right;">Conrad Aiken, from “The Cloisters.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?33a8e7fe